export default {
  ERR_NONE: 'ERR_NONE',
  NO_CONNECTION: 'NO_CONNECTION',
  TIMEOUT: 'TIMEOUT',
  SERVER_ERROR: 'SERVER_ERROR',
};
